export class AddEventQuestionPhotoRequest{
  EventID: number = -1;
  AuditResultID: number = -1;
  AuditResultDetailID: number = -1;
  QuestionID: number = -1;
  FileName: string = '';
  MimeType: string = '';
  PhotoContent: string = '';
  constructor(values: Object = {}){
    Object.assign(this, values);
  }
}
